import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Upload } from 'components';
import { useLang } from '../PlayerRegistration';
import './style.scss';

export const Step5 = () => {
  const { lang, t } = useLang();

  return (
    <Layout className="player-registration__step-5">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_5')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_5')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8} className="image-content">
        <Col xs={24} md={{ flex: '128px' }}>
          <Upload
            crop
            language={lang}
            name="profile_image"
            label={t('label_profile_photo')}
            rules={[{ required: true, message: t('error_profile_photo') }]}
          />
        </Col>
        <Col flex="1">
          <ul className="photo-requirements">
            <li>{t('text_clear_photo')}</li>
            <li>{t('text_solid_bg')}</li>
            <li>{t('text_image_size')}</li>
            <li>{t('text_image_format')}</li>
          </ul>
        </Col>
      </Row>
    </Layout>
  );
};
